// Path: ./src/app/components/RenderEditButtonTable/index.tsx
import { Button } from "@mui/material";
import { TouchRippleActions } from "@mui/material/ButtonBase/TouchRipple";
import { GridRenderCellParams } from "@mui/x-data-grid";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { messages } from "../../../locales/messages";
import { useTranslation } from "react-i18next";

export function RenderEditButton(props: GridRenderCellParams<any, Date> | any) {
  const { hasFocus } = props;
  const buttonElement = React.useRef<HTMLButtonElement | null>(null);
  const rippleRef = React.useRef<TouchRippleActions | null>(null);
  const { t } = useTranslation();

  React.useLayoutEffect(() => {
    if (hasFocus) {
      const input = buttonElement.current?.querySelector("input");
      input?.focus();
    } else if (rippleRef.current) {
      rippleRef.current.stop({} as any);
    }
  }, [hasFocus]);

  return (
    <Button
      component="button"
      ref={buttonElement}
      touchRippleRef={rippleRef}
      variant="text"
      size="small"
      tabIndex={hasFocus ? 0 : -1}
      style={{ textTransform: "capitalize" }}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === " ") {
          event.stopPropagation();
        }
      }}
      onClick={(event) => {
        /**
         * Click event handler for a Edit button in a table row.
         * Executes the provided onClick callback with the corresponding row data, if available.
         */
        event.stopPropagation();
        props?.onClick && props?.onClick(props?.row);
      }}
      startIcon={<EditIcon />}
      data-testid="rendereditbutton-test-id"
    >
      {t(messages.Edit())}
    </Button>
  );
}
